var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7998 8.83318V6.49985M5.7998 4.16651H5.80564M0.549805 4.13236V8.86734C0.549805 9.06721 0.549805 9.16715 0.579254 9.25628C0.605307 9.33513 0.647897 9.40751 0.704174 9.46858C0.767788 9.53761 0.855149 9.58615 1.02987 9.68322L5.34654 12.0814C5.51197 12.1733 5.59469 12.2192 5.68229 12.2372C5.75982 12.2532 5.83979 12.2532 5.91732 12.2372C6.00492 12.2192 6.08764 12.1733 6.25307 12.0814L10.5697 9.68322C10.7445 9.58615 10.8318 9.53761 10.8954 9.46858C10.9517 9.40751 10.9943 9.33513 11.0204 9.25628C11.0498 9.16715 11.0498 9.06721 11.0498 8.86734V4.13236C11.0498 3.93248 11.0498 3.83254 11.0204 3.74341C10.9943 3.66456 10.9517 3.59218 10.8954 3.53111C10.8318 3.46208 10.7445 3.41354 10.5697 3.31647L6.25307 0.918327C6.08764 0.826418 6.00492 0.780464 5.91732 0.762447C5.83979 0.746502 5.75982 0.746502 5.68229 0.762447C5.59469 0.780464 5.51197 0.826418 5.34654 0.918327L1.02987 3.31648C0.855149 3.41354 0.767788 3.46208 0.704174 3.53111C0.647897 3.59218 0.605307 3.66456 0.579254 3.74341C0.549805 3.83254 0.549805 3.93248 0.549805 4.13236Z",
    stroke: "#EF5858",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.47b0f659565be856d7a3a503617f5b5f.svg";
export { ForwardRef as ReactComponent };